import { ActionType, ActionTypes, State } from './types';

const initialState = {
  isLoading: false,
  error: '',
  data: undefined,
};

const legacyUserProfileReducer = (state: State = initialState, action: ActionType): State => {
  switch (action.type) {
    case ActionTypes.FETCH_USER_PROFILE_START:
      return {
        ...state,
        isLoading: true,
      };
    case ActionTypes.FETCH_USER_PROFILE_SUCCESS:
      return {
        ...state,
        isLoading: false,
        data: action.payload,
      };
    case ActionTypes.FETCH_USER_PROFILE_FAIL:
      return {
        ...state,
        isLoading: false,
        error: action.payload,
      };
    case ActionTypes.CLEAN_USER_PROFILE:
      return initialState;
    default:
      return state;
  }
};

export default legacyUserProfileReducer;
